
(function() {
  // Ensure DOM is ready
  function onReady(callback) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      callback();
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
  }

  // Wait for element to appear
  function waitForElement(selector, callback, timeout = 10000) {
    const el = document.querySelector(selector);
    if (el) return callback(el);

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        callback(el);
      }
    });

    const body = document.body;
    if (body) {
      observer.observe(body, { childList: true, subtree: true });
      if (timeout) setTimeout(() => observer.disconnect(), timeout);
    }
  }

  // Main logic
  onReady(() => {

    // Instant's own "Window Measuring Form" modal is baked into
    // instant-nlHrh9MXQrjomYCD.liquid with hardcoded ids (id="overlay",
    // id="closePopup", id="wTop", ...). When that section type is duplicated
    // more than once on a page, every duplicate's inline <script> for this
    // modal collides on `const overlay = document.getElementById('overlay')`
    // and throws (uncaught SyntaxError, unrelated to our own code) — only the
    // FIRST instance's modal script ever runs. Its document-level click
    // delegation still catches every .mg-measurement-calculator-link trigger
    // regardless of which duplicate it belongs to, so the link keeps working
    // (opens the first instance's modal) — but every later duplicate's modal
    // markup, with all its nested duplicate ids, is left inert in the DOM.
    // Remove those so the duplicate ids don't linger for anything else that
    // might do a getElementById lookup. This is a cleanup, not a fix for the
    // underlying collision — instant-nlHrh9MXQrjomYCD.liquid is auto-generated
    // by Instant and isn't hand-edited.
    const measuringGuideModals = document.querySelectorAll('.mg-overlay#overlay');
    measuringGuideModals.forEach(function (modal, i) {
      if (i > 0) modal.remove();
    });

    // The surviving modal is `position: fixed; z-index: 11111` (see its own
    // <style> in instant-nlHrh9MXQrjomYCD.liquid) — meant to sit above
    // everything, but `position: fixed` only escapes the VIEWPORT, not an
    // ancestor's stacking context. Left in its original position (inside the
    // first "Product Test Duplicate" section, itself full of Instant's own
    // transform-based scroll-reveal animations, each of which creates a new
    // stacking context), it can end up visually trapped behind whatever's in
    // a later, unrelated stacking context — like the second widget block.
    // Re-parent it directly onto <body> so it always escapes every ancestor's
    // stacking context and its own z-index is the only thing that matters.
    if (measuringGuideModals[0] && measuringGuideModals[0].parentElement !== document.body) {
      document.body.appendChild(measuringGuideModals[0]);
    }

    const primaryButtons = document.querySelectorAll('.guard-fit-button');
    const containers = document.querySelectorAll('.product-form-widget-container');

    // Patch getElementById to also search open shadow roots —
    // Truemed internally queries #truemed-instructions after we move it into shadow DOM
    const _origGetById = Document.prototype.getElementById;
    Document.prototype.getElementById = function(id) {
      const el = _origGetById.call(this, id);
      if (el) return el;
      for (const host of document.querySelectorAll('*')) {
        if (host.shadowRoot) {
          const found = host.shadowRoot.querySelector('#' + CSS.escape(id));
          if (found) return found;
        }
      }
      return null;
    };

    // Truemed: load in regular DOM so script finds it, then move into shadow DOM
    // after population so event listeners are preserved. Originally scoped to
    // only the first widget instance. Generalizing this to N instances is NOT
    // a simple "create N divs, load the script once" — Truemed's own
    // product-page-widget.min.js looks up a single, fixed
    // document.getElementById("truemed-instructions") (or
    // "truemed-prequalify"), then renames whatever it finds to
    // `truemed-instructions-${e}` internally — it expects exactly one live
    // target at a time, not a batch scan. So instead: process containers
    // strictly one at a time, always reusing the same plain
    // id="truemed-instructions" — Truemed's own script consumes/renames it
    // each round, freeing the id up for the next container once this
    // container's div has been populated (confirmed via the same
    // MutationObserver used before).
    function setupTruemedForContainer(containers, index) {
      if (index >= containers.length) return;

      const container = containers[index];
      const shadowRoot = container.shadowRoot;
      if (!shadowRoot) return setupTruemedForContainer(containers, index + 1);

      const addToCartBtn = shadowRoot.querySelector('.add-to-cart');
      if (!addToCartBtn) return setupTruemedForContainer(containers, index + 1);

      let truemedDiv = document.getElementById('truemed-instructions');
      if (!truemedDiv) {
        truemedDiv = document.createElement('div');
        truemedDiv.id = 'truemed-instructions';
        truemedDiv.style.fontSize = '14px';
        truemedDiv.setAttribute('icon-height', '12');
        truemedDiv.setAttribute('data-public-id', 'tm_qual_pjq29el3pd');
        truemedDiv.style.display = 'none';
        document.body.appendChild(truemedDiv);
      }

      const truemedBox = shadowRoot.querySelector('.form-footer-box__truemed');

      new MutationObserver(function(mutations, obs) {
        if (truemedDiv.children.length > 0) {
          obs.disconnect();
          addToCartBtn.insertAdjacentElement('afterend', truemedDiv);

          const truemedBtn = truemedDiv.querySelector('button');
          if (truemedBox) {
            truemedBox.style.display = '';
            const link = truemedBox.querySelector('a');
            if (link && truemedBtn) {
              link.addEventListener('click', function(e) {
                e.preventDefault();
                truemedBtn.click();
              });
            }
          }

          setupTruemedForContainer(containers, index + 1);
        }
      }).observe(truemedDiv, { childList: true });

      document.querySelectorAll('script[src*="truemed"]').forEach(function(s) { s.remove(); });
      const script = document.createElement('script');
      script.src = 'https://static.truemed.com/widgets/product-page-widget.min.js?t=' + Date.now();
      document.body.appendChild(script);
    }

    waitForElement('.product-form-widget-container', function() {
      setupTruemedForContainer(Array.from(document.querySelectorAll('.product-form-widget-container')), 0);
    });

    if (containers.length > 0) {
      (window.__log || console.log)('[custom.js] wiring', containers.length, 'guard-fit widget instance(s)');

      // Each widget instance's decoy "second" button should open its OWN
      // "Guard Fit Promise" overlay — but simulating a click on the native
      // .guard-fit-button (as before) goes through Instant's own internal
      // open-overlay resolution, which is keyed by a hardcoded
      // data-instant-action-id that's identical (duplicated) across every
      // "Product Test Duplicate" instance of this section type — same root
      // cause as the measuring-guide modal collision. In practice that means
      // clicking any instance's native button only reliably opens the FIRST
      // instance's overlay. Toggle the overlay's data-state directly instead
      // (the exact open/closed contract instant-*.css reads via
      // [data-instant-type="overlay"][data-state=...]), scoped by walking up
      // from this widget's own container to its enclosing Instant section
      // root (.__instant — shared marker on every Instant section regardless
      // of template) — this stays correct per-instance no matter how many
      // duplicates exist, and works unchanged on templates with only one
      // instance too.
      containers.forEach(function (container, i) {
        const secondaryButton = container.shadowRoot.querySelector('.guard-fit-button-second');
        if (!secondaryButton) return;

        secondaryButton.addEventListener('click', function (e) {
          e.preventDefault();
          const instanceRoot = container.closest('.__instant');
          const overlay = instanceRoot ? instanceRoot.querySelector('[data-instant-type="overlay"]') : null;
          if (overlay) {
            overlay.dataset.state = 'open';
          } else {
            const primaryButton = primaryButtons[i];
            if (primaryButton) primaryButton.click();
          }
        });

        // instant-nlHrh9MXQrjomYCD.liquid's own inline script already wires
        // .mg-measurement-calculator-link clicks *inside* the shadow root for
        // this exact reason (retargeted click events from inside a shadow
        // tree can't be caught by a plain document-level listener), but it
        // does so via a hardcoded, unsuffixed
        // document.getElementById('product-form-container') lookup (plus a
        // matching MutationObserver) — it only ever finds the first widget
        // instance's container, never a suffixed one. Do the same wiring
        // ourselves for every instance, reusing that same script's global
        // openModal() (there's only one measuring-guide modal left on the
        // page after the #overlay de-dup cleanup above, so every instance
        // opens that same one — calling it twice for the first instance,
        // once from Instant's own listener and once from ours, is harmless
        // since openModal() just adds a CSS class).
        if (container.shadowRoot && typeof openModal === 'function') {
          container.shadowRoot.addEventListener('click', function (e) {
            if (e.target.closest('.mg-measurement-calculator-link')) {
              e.preventDefault();
              openModal();
            }
          });
        }
      });

      const odOverlay = document.getElementById('OdOverlay');
      const odCloseX = document.getElementById('OdCloseX');

      // One shared OD modal for the whole page — collect open-triggers from
      // every widget instance's shadow root, not just one.
      const odOpenElements = Array.from(containers).flatMap((container) =>
        container.shadowRoot ? Array.from(container.shadowRoot.querySelectorAll('.od-info-link')) : []
      );

      // if (odOverlay && odCloseX) {
        function odOpen(){
          odOverlay.dataset.open = "true";
          odOverlay.setAttribute("aria-hidden", "false");
          // lock background scroll
          document.body.style.overflow = "hidden";
        }

        function odClose(){
          odOverlay.dataset.open = "false";
          odOverlay.setAttribute("aria-hidden", "true");
          document.body.style.overflow = "";
          // quick reset so animation replays next open
          const odModal = odOverlay.querySelector('.od-modal');
          odModal.style.animation = "none";
          // force reflow
          void odModal.offsetHeight;
          odModal.style.animation = "";
        }

        // Attach click event to all elements with .input-opening-direction class
        odOpenElements.forEach(element => {
          element.addEventListener('click', odOpen);
        });

        odCloseX.addEventListener('click', odClose);

        // close on overlay click (but not when clicking modal)
        odOverlay.addEventListener('click', (e) => {
          if(e.target === odOverlay) odClose();
        });

        // close on Esc
        window.addEventListener('keydown', (e) => {
          if(e.key === 'Escape' && odOverlay.dataset.open === "true") odClose();
        });
      // }

    }
    

    
  });
})();



